import { z } from 'zod';
import { AlphanumericLabelSchema, LocationSchema } from '../common/schemas';

/**
 * Shared & Helper Schemas
 */

/**
 * DB Schemas
 */

export const DBRoomLocationSchema = LocationSchema;
export const DBRoomRoomIdSchema = z
  .string()
  .regex(/^([1-9][0-9]*|[A-Za-z][A-Za-z0-9]*)$/)
  .min(1)
  .max(4);
export const DBRoomLabelSchema = AlphanumericLabelSchema.min(1).max(16);

export const DBRoomSchema = z.object({
  location: DBRoomLocationSchema,
  roomId: DBRoomRoomIdSchema,
  label: DBRoomLabelSchema,
});

/**
 * Client Schemas
 */

export const RoomLocationSchema = DBRoomLocationSchema;
export const RoomRoomIdSchema = DBRoomRoomIdSchema;
export const RoomLabelSchema = DBRoomLabelSchema;

export const RoomSchema = z.object({
  location: RoomLocationSchema.meta({ title: 'Location' }),
  roomId: RoomRoomIdSchema.meta({ title: 'Room ID' }),
  label: RoomLabelSchema.meta({ title: 'Label' }),
});
